import { Table } from "reactstrap";
import { useState, useContext, useEffect, useRef } from "react";
import { AppContext } from '../application/provider';
import CajaDatosService from "../axios_services/cajaflujodatos.service";
import Loader from "../components/Loader/Loader";
import { ButtonUpdate, ButtonInsert, ButtonDelete } from '../components/Buttons/Buttons';
import ModalCajaFlujoConcepto from '../components/Modal/ModalCajaFlujoConcepto';
import ModalCajaFlujoCategoria from '../components/Modal/ModalCajaFlujoCategoria';
import ModalCajaFlujoCatalogoSimple from '../components/Modal/ModalCajaFlujoCatalogoSimple';
import ModalCajaCategoriaMovimiento from '../components/Modal/ModalCajaCategoriaMovimiento';
import TabsWithTable from '../components/Tabs/TabsWithTable';
import './CajaFlujoDatos.css';

function CajaFlujoDatos() {
    const [state] = useContext(AppContext);
    const [loadingConceptos, setLoadingConceptos] = useState(false);
    const [loadingCategorias, setLoadingCategorias] = useState(false);
    const [loadingTiposComprobante, setLoadingTiposComprobante] = useState(false);
    const [loadingResponsables, setLoadingResponsables] = useState(false);
    const [loadingCategoriasMovimiento, setLoadingCategoriasMovimiento] = useState(false);
    const [tabActiva, setTabActiva] = useState('concepto');
    
    const [conceptos, setConceptos] = useState([]);
    const [isModalConceptoOpen, setIsModalConceptoOpen] = useState(false);
    const [conceptoEditar, setConceptoEditar] = useState(null);
    
    const [categorias, setCategorias] = useState([]);
    const [isModalCategoriaOpen, setIsModalCategoriaOpen] = useState(false);
    const [categoriaEditar, setCategoriaEditar] = useState(null);

    const [tiposComprobante, setTiposComprobante] = useState([]);
    const [isModalTipoComprobanteOpen, setIsModalTipoComprobanteOpen] = useState(false);
    const [tipoComprobanteEditar, setTipoComprobanteEditar] = useState(null);

    const [responsables, setResponsables] = useState([]);
    const [isModalResponsableOpen, setIsModalResponsableOpen] = useState(false);
    const [responsableEditar, setResponsableEditar] = useState(null);

    const [categoriasMovimiento, setCategoriasMovimiento] = useState([]);
    const [isModalCategoriaMovimientoOpen, setIsModalCategoriaMovimientoOpen] = useState(false);
    const [categoriaMovimientoEditar, setCategoriaMovimientoEditar] = useState(null);
    
    const initialFetchDone = useRef(false);
    const conceptosFetched = useRef(false);
    const categoriasFetched = useRef(false);
    const tiposComprobanteFetched = useRef(false);
    const responsablesFetched = useRef(false);
    const categoriasMovimientoFetched = useRef(false);
    
    const [tipo_categoria] = useState(state.catalogos.tipos.filter(t => t.categoria_id == 27));

    useEffect(() => {
        if (!initialFetchDone.current) {
            getCajaConceptos();
            initialFetchDone.current = true;
        }
    }, []);

    useEffect(() => {
        if (tabActiva === 'concepto' && !conceptosFetched.current) {
            getCajaConceptos();
        } else if (tabActiva === 'categoria' && !categoriasFetched.current) {
            getCajaCategorias();
        } else if (tabActiva === 'tipoComprobante' && !tiposComprobanteFetched.current) {
            getCajaTiposComprobante();
        } else if (tabActiva === 'responsable' && !responsablesFetched.current) {
            getCajaResponsables();
        } else if (tabActiva === 'categoriaMovimiento' && !categoriasMovimientoFetched.current) {
            getCajaCategoriasMovimiento();
        }
    }, [tabActiva]);

    const getCajaConceptos = async () => {
        setLoadingConceptos(true);
        try {
            const response = await CajaDatosService.getCajaConcepto(
                state.user?.perfil_id
            );
            
            if (response.success && response.data) {
                setConceptos(response.data);
            } else {
                setConceptos([]);
            }
            conceptosFetched.current = true;
        } catch (error) {
            console.error('Error al obtener conceptos:', error);
            setConceptos([]);
            const errorMsg = error.response?.data?.message || 'Error al cargar los conceptos';
            alert(errorMsg);
        } finally {
            setLoadingConceptos(false);
        }
    };

    const getCajaCategorias = async () => {
        setLoadingCategorias(true);
        try {
            const response = await CajaDatosService.getCajaCategoria(
                state.user?.perfil_id
            );
            
            if (response.success && response.data) {
                setCategorias(response.data);
            } else {
                setCategorias([]);
            }
            categoriasFetched.current = true;
        } catch (error) {
            console.error('Error al obtener categorías:', error);
            setCategorias([]);
            const errorMsg = error.response?.data?.message || 'Error al cargar las categorías';
            alert(errorMsg);
        } finally {
            setLoadingCategorias(false);
        }
    };

    const getCajaTiposComprobante = async () => {
        setLoadingTiposComprobante(true);
        try {
            const response = await CajaDatosService.getCajaTipoComprobante(
                state.user?.perfil_id
            );
            
            if (response.success && response.data) {
                setTiposComprobante(response.data);
            } else {
                setTiposComprobante([]);
            }
            tiposComprobanteFetched.current = true;
        } catch (error) {
            console.error('Error al obtener tipos de comprobante:', error);
            setTiposComprobante([]);
            const errorMsg = error.response?.data?.message || 'Error al cargar los tipos de comprobante';
            alert(errorMsg);
        } finally {
            setLoadingTiposComprobante(false);
        }
    };

    const getCajaResponsables = async () => {
        setLoadingResponsables(true);
        try {
            const response = await CajaDatosService.getCajaResponsable(
                state.user?.perfil_id
            );
            
            if (response.success && response.data) {
                setResponsables(response.data);
            } else {
                setResponsables([]);
            }
            responsablesFetched.current = true;
        } catch (error) {
            console.error('Error al obtener responsables:', error);
            setResponsables([]);
            const errorMsg = error.response?.data?.message || 'Error al cargar los responsables';
            alert(errorMsg);
        } finally {
            setLoadingResponsables(false);
        }
    };

    const getCajaCategoriasMovimiento = async () => {
        setLoadingCategoriasMovimiento(true);
        try {
            const response = await CajaDatosService.getCajaCategoriaMovimiento(
                state.user?.perfil_id
            );
            
            if (response.success && response.data) {
                setCategoriasMovimiento(response.data);
            } else {
                setCategoriasMovimiento([]);
            }
            categoriasMovimientoFetched.current = true;
        } catch (error) {
            console.error('Error al obtener categorías de movimiento:', error);
            setCategoriasMovimiento([]);
            const errorMsg = error.response?.data?.message || 'Error al cargar las categorías de movimiento';
            alert(errorMsg);
        } finally {
            setLoadingCategoriasMovimiento(false);
        }
    };

    const getTipoCategoria = (tipoId) => {
        const tipo = tipo_categoria.find(t => t.tipo_id == tipoId);
        return tipo ? tipo.descripcion : tipoId;
    };

    const handleEliminarConcepto = async (conceptoId) => {
        if (!window.confirm('¿Está seguro que desea eliminar este concepto?')) {
            return;
        }

        try {
            setLoadingConceptos(true);
            await CajaDatosService.deleteCajaConcepto({
                caja_concepto_id: conceptoId,
                perfil_id: state.user?.perfil_id
            });
            await getCajaConceptos();
            alert('Concepto eliminado correctamente');
        } catch (error) {
            console.error('Error al eliminar concepto:', error);
            const errorMsg = error.response?.data?.message || 'Error al eliminar el concepto';
            alert(errorMsg);
        } finally {
            setLoadingConceptos(false);
        }
    };

    const handleNuevoConcepto = () => {
        setConceptoEditar(null);
        setIsModalConceptoOpen(true);
    };

    const handleEditarConcepto = (concepto) => {
        setConceptoEditar(concepto);
        setIsModalConceptoOpen(true);
    };

    const handleCloseModalConcepto = () => {
        setIsModalConceptoOpen(false);
        setConceptoEditar(null);
    };

    const handleSaveConcepto = async (conceptoData) => {
        try {
            const dataConPerfil = {
                ...conceptoData,
                perfil_id: state.user?.perfil_id
            };
            
            if (conceptoEditar) {
                await CajaDatosService.updateCajaConcepto({
                    ...dataConPerfil,
                    caja_concepto_id: conceptoEditar.caja_concepto_id
                });
                alert('Concepto actualizado correctamente');
            } else {
                await CajaDatosService.insertCajaConcepto(dataConPerfil);
                alert('Concepto agregado correctamente');
            }
            
            await getCajaConceptos();
        } catch (error) {
            console.error('Error al guardar concepto:', error);
            const errorMsg = error.response?.data?.message || 'Error al guardar el concepto';
            alert(errorMsg);
            throw error;
        }
    };

    const handleEliminarCategoria = async (categoriaId) => {
        if (!window.confirm('¿Está seguro que desea eliminar esta categoría?')) {
            return;
        }

        try {
            setLoadingCategorias(true);
            await CajaDatosService.deleteCajaCategoria({
                caja_categoria_id: categoriaId,
                perfil_id: state.user?.perfil_id
            });
            await getCajaCategorias();
            alert('Categoría eliminada correctamente');
        } catch (error) {
            console.error('Error al eliminar categoría:', error);
            const errorMsg = error.response?.data?.message || 'Error al eliminar la categoría';
            alert(errorMsg);
        } finally {
            setLoadingCategorias(false);
        }
    };

    const handleNuevaCategoria = () => {
        setCategoriaEditar(null);
        setIsModalCategoriaOpen(true);
    };

    const handleEditarCategoria = (categoria) => {
        setCategoriaEditar(categoria);
        setIsModalCategoriaOpen(true);
    };

    const handleCloseModalCategoria = () => {
        setIsModalCategoriaOpen(false);
        setCategoriaEditar(null);
    };

    const handleSaveCategoria = async (categoriaData) => {
        try {
            const dataConPerfil = {
                ...categoriaData,
                perfil_id: state.user?.perfil_id
            };
            
            if (categoriaEditar) {
                await CajaDatosService.updateCajaCategoria({
                    ...dataConPerfil,
                    caja_categoria_id: categoriaEditar.caja_categoria_id
                });
                alert('Categoría actualizada correctamente');
            } else {
                await CajaDatosService.insertCajaCategoria(dataConPerfil);
                alert('Categoría agregada correctamente');
            }
            
            await getCajaCategorias();
        } catch (error) {
            console.error('Error al guardar categoría:', error);
            const errorMsg = error.response?.data?.message || 'Error al guardar la categoría';
            alert(errorMsg);
            throw error;
        }
    };

    const handleEliminarTipoComprobante = async (tipoComprobanteId) => {
        if (!window.confirm('¿Está seguro que desea eliminar este tipo de comprobante?')) {
            return;
        }

        try {
            setLoadingTiposComprobante(true);
            await CajaDatosService.deleteCajaTipoComprobante({
                caja_tipo_comprobante_id: tipoComprobanteId,
                perfil_id: state.user?.perfil_id
            });
            await getCajaTiposComprobante();
            alert('Tipo de comprobante eliminado correctamente');
        } catch (error) {
            console.error('Error al eliminar tipo de comprobante:', error);
            const errorMsg = error.response?.data?.message || 'Error al eliminar el tipo de comprobante';
            alert(errorMsg);
        } finally {
            setLoadingTiposComprobante(false);
        }
    };

    const handleNuevoTipoComprobante = () => {
        setTipoComprobanteEditar(null);
        setIsModalTipoComprobanteOpen(true);
    };

    const handleEditarTipoComprobante = (tipoComprobante) => {
        setTipoComprobanteEditar(tipoComprobante);
        setIsModalTipoComprobanteOpen(true);
    };

    const handleCloseModalTipoComprobante = () => {
        setIsModalTipoComprobanteOpen(false);
        setTipoComprobanteEditar(null);
    };

    const handleSaveTipoComprobante = async (tipoComprobanteData) => {
        try {
            const dataConPerfil = {
                ...tipoComprobanteData,
                perfil_id: state.user?.perfil_id
            };

            if (tipoComprobanteEditar) {
                await CajaDatosService.updateCajaTipoComprobante({
                    ...dataConPerfil,
                    caja_tipo_comprobante_id: tipoComprobanteEditar.caja_tipo_comprobante_id
                });
                alert('Tipo de comprobante actualizado correctamente');
            } else {
                await CajaDatosService.insertCajaTipoComprobante(dataConPerfil);
                alert('Tipo de comprobante agregado correctamente');
            }

            await getCajaTiposComprobante();
        } catch (error) {
            console.error('Error al guardar tipo de comprobante:', error);
            const errorMsg = error.response?.data?.message || 'Error al guardar el tipo de comprobante';
            alert(errorMsg);
            throw error;
        }
    };

    const handleEliminarResponsable = async (responsableId) => {
        if (!window.confirm('¿Está seguro que desea eliminar este responsable?')) {
            return;
        }

        try {
            setLoadingResponsables(true);
            await CajaDatosService.deleteCajaResponsable({
                caja_responsable_id: responsableId,
                perfil_id: state.user?.perfil_id
            });
            await getCajaResponsables();
            alert('Responsable eliminado correctamente');
        } catch (error) {
            console.error('Error al eliminar responsable:', error);
            const errorMsg = error.response?.data?.message || 'Error al eliminar el responsable';
            alert(errorMsg);
        } finally {
            setLoadingResponsables(false);
        }
    };

    const handleNuevoResponsable = () => {
        setResponsableEditar(null);
        setIsModalResponsableOpen(true);
    };

    const handleEditarResponsable = (responsable) => {
        setResponsableEditar(responsable);
        setIsModalResponsableOpen(true);
    };

    const handleCloseModalResponsable = () => {
        setIsModalResponsableOpen(false);
        setResponsableEditar(null);
    };

    const handleSaveResponsable = async (responsableData) => {
        try {
            const dataConPerfil = {
                ...responsableData,
                perfil_id: state.user?.perfil_id
            };

            if (responsableEditar) {
                await CajaDatosService.updateCajaResponsable({
                    ...dataConPerfil,
                    caja_responsable_id: responsableEditar.caja_responsable_id
                });
                alert('Responsable actualizado correctamente');
            } else {
                await CajaDatosService.insertCajaResponsable(dataConPerfil);
                alert('Responsable agregado correctamente');
            }

            await getCajaResponsables();
        } catch (error) {
            console.error('Error al guardar responsable:', error);
            const errorMsg = error.response?.data?.message || 'Error al guardar el responsable';
            alert(errorMsg);
            throw error;
        }
    };

    const handleEliminarCategoriaMovimiento = async (categoriaMovimientoId) => {
        if (!window.confirm('¿Está seguro que desea eliminar esta categoría de movimiento?')) {
            return;
        }

        try {
            setLoadingCategoriasMovimiento(true);
            await CajaDatosService.deleteCajaCategoriaMovimiento({
                caja_categoria_movimiento_id: categoriaMovimientoId,
                perfil_id: state.user?.perfil_id
            });
            await getCajaCategoriasMovimiento();
            alert('Categoría de movimiento eliminada correctamente');
        } catch (error) {
            console.error('Error al eliminar categoría de movimiento:', error);
            const errorMsg = error.response?.data?.message || 'Error al eliminar la categoría de movimiento';
            alert(errorMsg);
        } finally {
            setLoadingCategoriasMovimiento(false);
        }
    };

    const handleNuevaCategoriaMovimiento = () => {
        setCategoriaMovimientoEditar(null);
        setIsModalCategoriaMovimientoOpen(true);
    };

    const handleEditarCategoriaMovimiento = (categoriaMovimiento) => {
        setCategoriaMovimientoEditar(categoriaMovimiento);
        setIsModalCategoriaMovimientoOpen(true);
    };

    const handleCloseModalCategoriaMovimiento = () => {
        setIsModalCategoriaMovimientoOpen(false);
        setCategoriaMovimientoEditar(null);
    };

    const handleSaveCategoriaMovimiento = async (categoriaMovimientoData) => {
        try {
            const dataConPerfil = {
                ...categoriaMovimientoData,
                perfil_id: state.user?.perfil_id
            };

            if (categoriaMovimientoEditar) {
                await CajaDatosService.updateCajaCategoriaMovimiento({
                    ...dataConPerfil,
                    caja_categoria_movimiento_id: categoriaMovimientoEditar.caja_categoria_movimiento_id
                });
                alert('Categoría de movimiento actualizada correctamente');
            } else {
                await CajaDatosService.insertCajaCategoriaMovimiento(dataConPerfil);
                alert('Categoría de movimiento agregada correctamente');
            }

            await getCajaCategoriasMovimiento();
        } catch (error) {
            console.error('Error al guardar categoría de movimiento:', error);
            const errorMsg = error.response?.data?.message || 'Error al guardar la categoría de movimiento';
            alert(errorMsg);
            throw error;
        }
    };

    const mostrarAcciones = () => {
        return [8, 12, 13, 21].includes(Number(state.user?.perfil_id));
    };

    const handleTabChange = (tabKey) => {
        setTabActiva(tabKey);
    };

    const getActionButton = () => {
        if (!mostrarAcciones()) return null;

        const config = {
            concepto: {
                loading: loadingConceptos,
                onClick: handleNuevoConcepto
            },
            categoria: {
                loading: loadingCategorias,
                onClick: handleNuevaCategoria
            },
            tipoComprobante: {
                loading: loadingTiposComprobante,
                onClick: handleNuevoTipoComprobante
            },
            responsable: {
                loading: loadingResponsables,
                onClick: handleNuevoResponsable
            },
            categoriaMovimiento: {
                loading: loadingCategoriasMovimiento,
                onClick: handleNuevaCategoriaMovimiento
            }
        };

        const activeConfig = config[tabActiva] || config.concepto;

        return (
            <ButtonInsert 
                onClick={activeConfig.onClick} 
                disabled={activeConfig.loading}
            />
        );
    };

    const renderConceptosTable = () => {
        if (loadingConceptos) {
            return <Loader />;
        }

        return (
            <div className="table-container">
                <Table hover size="sm">
                    <thead>
                        <tr>
                            <th>Categoría</th>
                            <th>Concepto</th>
                            {mostrarAcciones() && <th>Acciones</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {conceptos.length > 0 ? (
                            conceptos.map((concepto) => (
                                <tr key={concepto.caja_concepto_id}>
                                    <td>{concepto.nombre_categoria}</td>
                                    <td>{concepto.nombre_concepto || 'Sin nombre'}</td>
                                    {mostrarAcciones() && (
                                        <td>
                                            <div className="acciones-container">
                                                <ButtonUpdate 
                                                    onClick={() => handleEditarConcepto(concepto)}
                                                />
                                                <ButtonDelete 
                                                    onClick={() => handleEliminarConcepto(concepto.caja_concepto_id)} 
                                                />
                                            </div>
                                        </td>
                                    )}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={mostrarAcciones() ? "3" : "2"} className="text-center">
                                    No hay conceptos disponibles
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        );
    };

    const renderCategoriasTable = () => {
        if (loadingCategorias) {
            return <Loader />;
        }

        return (
            <div className="table-container">
                <Table hover size="sm">
                    <thead>
                        <tr>
                            <th>Nombre Categoría</th>
                            <th>Tipo</th>
                            {mostrarAcciones() && <th>Acciones</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {categorias.length > 0 ? (
                            categorias.map((categoria) => (
                                <tr key={categoria.caja_categoria_id}>
                                    <td>{categoria.nombre_categoria}</td>
                                    <td>{getTipoCategoria(categoria.tipo_id)}</td>
                                    {mostrarAcciones() && (
                                        <td>
                                            <div className="acciones-container">
                                                <ButtonUpdate 
                                                    onClick={() => handleEditarCategoria(categoria)}
                                                />
                                                <ButtonDelete 
                                                    onClick={() => handleEliminarCategoria(categoria.caja_categoria_id)} 
                                                />
                                            </div>
                                        </td>
                                    )}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={mostrarAcciones() ? "3" : "2"} className="text-center">
                                    No hay categorías disponibles
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        );
    };

    const renderTiposComprobanteTable = () => {
        if (loadingTiposComprobante) {
            return <Loader />;
        }

        return (
            <div className="table-container">
                <Table hover size="sm">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nombre</th>
                            {mostrarAcciones() && <th>Acciones</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {tiposComprobante.length > 0 ? (
                            tiposComprobante.map((tipoComprobante) => (
                                <tr key={tipoComprobante.caja_tipo_comprobante_id}>
                                    <td>{tipoComprobante.caja_tipo_comprobante_id}</td>
                                    <td>{tipoComprobante.nombre_tipo_comprobante}</td>
                                    {mostrarAcciones() && (
                                        <td>
                                            <div className="acciones-container">
                                                <ButtonUpdate 
                                                    onClick={() => handleEditarTipoComprobante(tipoComprobante)}
                                                />
                                                <ButtonDelete 
                                                    onClick={() => handleEliminarTipoComprobante(tipoComprobante.caja_tipo_comprobante_id)} 
                                                />
                                            </div>
                                        </td>
                                    )}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={mostrarAcciones() ? "3" : "2"} className="text-center">
                                    No hay tipos de comprobante disponibles
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        );
    };

    const renderResponsablesTable = () => {
        if (loadingResponsables) {
            return <Loader />;
        }

        return (
            <div className="table-container">
                <Table hover size="sm">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nombre del Responsable</th>
                            {mostrarAcciones() && <th>Acciones</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {responsables.length > 0 ? (
                            responsables.map((responsable) => (
                                <tr key={responsable.caja_responsable_id}>
                                    <td>{responsable.caja_responsable_id}</td>
                                    <td>{responsable.nombre_responsable}</td>
                                    {mostrarAcciones() && (
                                        <td>
                                            <div className="acciones-container">
                                                <ButtonUpdate 
                                                    onClick={() => handleEditarResponsable(responsable)}
                                                />
                                                <ButtonDelete 
                                                    onClick={() => handleEliminarResponsable(responsable.caja_responsable_id)} 
                                                />
                                            </div>
                                        </td>
                                    )}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={mostrarAcciones() ? "3" : "2"} className="text-center">
                                    No hay responsables disponibles
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        );
    };

    const renderCategoriasMovimientoTable = () => {
        if (loadingCategoriasMovimiento) {
            return <Loader />;
        }

        return (
            <div className="table-container">
                <Table hover size="sm">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nombre</th>
                            <th>Tipo</th>
                            {mostrarAcciones() && <th>Acciones</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {categoriasMovimiento.length > 0 ? (
                            categoriasMovimiento.map((categoriaMovimiento) => (
                                <tr key={categoriaMovimiento.caja_categoria_movimiento_id}>
                                    <td>{categoriaMovimiento.caja_categoria_movimiento_id}</td>
                                    <td>{categoriaMovimiento.nombre_categoria_movimiento}</td>
                                    <td>{categoriaMovimiento.tipo === 'ingreso' ? 'Ingreso' : 'Egreso'}</td>
                                    {mostrarAcciones() && (
                                        <td>
                                            <div className="acciones-container">
                                                <ButtonUpdate 
                                                    onClick={() => handleEditarCategoriaMovimiento(categoriaMovimiento)}
                                                />
                                                <ButtonDelete 
                                                    onClick={() => handleEliminarCategoriaMovimiento(categoriaMovimiento.caja_categoria_movimiento_id)} 
                                                />
                                            </div>
                                        </td>
                                    )}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={mostrarAcciones() ? "4" : "3"} className="text-center">
                                    No hay categorías de movimiento disponibles
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        );
    };

    const tabs = [
        {
            key: 'concepto',
            label: 'Conceptos',
            content: renderConceptosTable()
        },
        {
            key: 'categoria',
            label: 'Categorías',
            content: renderCategoriasTable()
        },
        {
            key: 'tipoComprobante',
            label: 'Tipo de Comprobante',
            content: renderTiposComprobanteTable()
        },
        {
            key: 'responsable',
            label: 'Responsables',
            content: renderResponsablesTable()
        },
        {
            key: 'categoriaMovimiento',
            label: 'Categoría de Movimiento',
            content: renderCategoriasMovimientoTable()
        }
    ];

    return (
        <>
            <div className="flex items-center justify-between mb-4">
                <h1>FLUJO DE CAJA - DATOS</h1>
            </div>

            <TabsWithTable
                tabs={tabs}
                defaultTab="concepto"
                actionButton={getActionButton()}
                onTabChange={handleTabChange}
            />

            <ModalCajaFlujoConcepto
                onSave={handleSaveConcepto}
                onClose={handleCloseModalConcepto}
                isOpen={isModalConceptoOpen}
                perfilId={state.user?.perfil_id}
                conceptoEditar={conceptoEditar}
            />

            <ModalCajaFlujoCategoria
                onSave={handleSaveCategoria}
                onClose={handleCloseModalCategoria}
                isOpen={isModalCategoriaOpen}
                categoriaEditar={categoriaEditar}
            />

            <ModalCajaFlujoCatalogoSimple
                onSave={handleSaveTipoComprobante}
                onClose={handleCloseModalTipoComprobante}
                isOpen={isModalTipoComprobanteOpen}
                itemEditar={tipoComprobanteEditar}
                fieldName="nombre_tipo_comprobante"
                title="AGREGAR TIPO DE COMPROBANTE"
                editTitle="EDITAR TIPO DE COMPROBANTE"
                label="Nombre"
                placeholder="Ingrese el nombre del tipo de comprobante"
            />

            <ModalCajaFlujoCatalogoSimple
                onSave={handleSaveResponsable}
                onClose={handleCloseModalResponsable}
                isOpen={isModalResponsableOpen}
                itemEditar={responsableEditar}
                fieldName="nombre_responsable"
                title="AGREGAR RESPONSABLE"
                editTitle="EDITAR RESPONSABLE"
                label="Nombre del Responsable"
                placeholder="Ingrese el nombre del responsable"
            />

            <ModalCajaCategoriaMovimiento
                onSave={handleSaveCategoriaMovimiento}
                onClose={handleCloseModalCategoriaMovimiento}
                isOpen={isModalCategoriaMovimientoOpen}
                categoriaMovimientoEditar={categoriaMovimientoEditar}
            />
        </>
    );
}

export default CajaFlujoDatos;
